module.exports = __webpack_public_path__ + "img/tysabri_logo.8aa9ae85.png";